import { chargeApi } from '@/core/api/charge'

export const { useConfirmPaymentMutation, useSetPriceMutation, useStartPaymentByReceiverIDMutation } = chargeApi
